import { render, staticRenderFns } from "./managers-create-form.vue?vue&type=template&id=18fbe4e4&lang=pug&"
import script from "./managers-create-form.vue?vue&type=script&lang=js&"
export * from "./managers-create-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports